import React, { Component } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTable from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import { getList } from './erroGeralActions';
import { PAGE_SIZE } from '../common/utils/pageSize';
import Button from '../common/form/button';
import TicketSuporteForm from '../ticket_suporte/ticketSuporteForm';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class ControladorErroGeralList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      pages: null,
      loading: true,
      selectedDays: 7,
      grupoId: '',
      controladorId: '',
      showTicketModal: false,
      selectedError: null,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleSetGrupo = this.handleSetGrupo.bind(this);
    this.handleSetControlador = this.handleSetControlador.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
    this.handleDaysChange = this.handleDaysChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.onDataLoaded && prevProps.data !== this.props.data) {
      this.props.onDataLoaded();
    }
  }

  fetchData(state) {
    this.setState({ loading: true });

    this.lastTableState = state;
    const hasDateFilter = state.filtered && state.filtered.some(item => item.id === 'data_erro' && item.value);
    const daysFilter = hasDateFilter ? null : this.state.selectedDays;

    this.props.getList(state.page, state.sorted, state.filtered, daysFilter).then(() => {
      this.setState({ loading: false });
    });
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  handleSetGrupo(value) {
    this.setState({ grupoId: value });
  }

  handleSetControlador(value) {
    this.setState({ controladorId: value });
  }

  handleShowTicketModal(error) {
    this.setState({ showTicketModal: true, selectedError: error });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedError: null });
  }

  handleDaysChange(days) {
    this.setState({ loading: true, selectedDays: days }, () => {
      if (this.lastTableState) {
        const nextState = {
          ...this.lastTableState,
          page: 0,
        };

        this.fetchData(nextState);
      }
    });
  }

  render() {
    moment.locale('pt-br');
    const { data, total } = this.props;
    const pages = Math.ceil(total / PAGE_SIZE);
    const totalPagina = data ? data.length : 0;
    const periodOptions = [0, 7, 15, 30, 90];
    const columns = [
      {
        Header: 'Data',
        accessor: 'data_erro',
        width: 135,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            type="date"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Hora',
        accessor: 'hora_erro',
        width: 110,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Mensagem',
        accessor: 'mensagem',
        width: 620,
        filterable: true,
        resizable: true,
        className: 'column_grid column_left',
        Cell: ({ original }) => original.mensagem_humana || '-',
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            type="text"
            placeholder="Digite ao menos 3 letras"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico_id',
        width: 95,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Controlador',
        accessor: 'numero_controlador',
        width: 120,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Ticket',
        accessor: 'id',
        width: 80,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-ticket-${error.id_erro}`}>Abrir Ticket</Tooltip>}
          >
            <Button
              className="btn btn-warning btn-sm"
              icon="exclamation-triangle"
              onClick={() => this.handleShowTicketModal(error)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2em',
                color: '#f39c12',
                padding: '0 5px',
              }}
            />
          </OverlayTrigger>
        ),
      },
    ];

    const { selectedError } = this.state;
    let initialTicketData = null;
    if (selectedError) {
      initialTicketData = {
        titulo: `Erro no Controlador ${selectedError.numero_controlador}`,
        descricao: `Mensagem de Erro: ${selectedError.mensagem_humana || selectedError.mensagem}

Detalhes:
- Data: ${moment(selectedError.data_erro).format('DD/MM/YYYY')}
- Hora: ${selectedError.hora_erro}
- Controlador: ${selectedError.numero_controlador}
- Grupo Físico: ${selectedError.grupo_fisico_id}`,
        grupo_fisico_id: selectedError.grupo_fisico_id,
        numero_controlador: selectedError.numero_controlador,
        controlador_erro_id: selectedError.id_erro,
        isFromError: true,
        controlador_id: '',
      };
    }

    return (
      <div>
        <style>{`
          .erro-geral-toolbar-actions {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: flex-end;
          }

          .erro-geral-toolbar-meta {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            border-radius: 999px;
            background: rgba(241, 245, 249, 0.7);
            color: #475569;
            padding: 7px 11px;
            font-size: 12px;
            font-weight: 500;
          }

          .erro-geral-days-group {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px;
            border-radius: 999px;
            background: rgba(248, 250, 252, 0.96);
            border: 1px solid rgba(226, 232, 240, 0.95);
          }

          .erro-geral-days-button {
            border: 0;
            border-radius: 999px;
            background: transparent;
            color: #64748b;
            font-size: 12px;
            font-weight: 500;
            padding: 7px 12px;
            transition: all 0.2s ease;
          }

          .erro-geral-days-button:hover {
            background: rgba(59, 130, 246, 0.08);
            color: #334155;
          }

          .erro-geral-days-button.active {
            background: rgba(59, 130, 246, 0.1);
            color: #1d4ed8;
            font-weight: 600;
          }

          .erro-geral-premium-table .ReactTable .rt-th.column_left,
          .erro-geral-premium-table .ReactTable .rt-td.column_left {
            justify-content: flex-start;
            text-align: left;
          }

          .erro-geral-premium-table .ReactTable .rt-th.column_left .rt-resizable-header-content,
          .erro-geral-premium-table .ReactTable .rt-th.column_left .rt-th-content {
            width: 100%;
            text-align: left;
            justify-content: flex-start;
          }

          @media (max-width: 767px) {
            .erro-geral-toolbar-actions {
              justify-content: flex-start;
            }
          }
        `}</style>
        <div className="erro-geral-premium-table">
          <PremiumTableShell
            summary={`${totalPagina} registro(s) na página atual, ${total || 0} erros no período selecionado`}
            loading={this.state.loading || this.props.forceLoading}
            loadingText="Carregando erros..."
            tableMinWidth={1160}
            toolbarRight={
              <div className="erro-geral-toolbar-actions">
                <span className="erro-geral-toolbar-meta">Período recente</span>
                <div className="erro-geral-days-group">
                  {periodOptions.map(days => (
                    <button
                      key={days}
                      type="button"
                      className={`erro-geral-days-button ${this.state.selectedDays === days ? 'active' : ''}`}
                      onClick={() => this.handleDaysChange(days)}
                    >
                      {days === 0 ? 'Todo período' : `${days} dias`}
                    </button>
                  ))}
                </div>
              </div>
            }
          >
            <ReactTable
              manual
              data={data}
              columns={columns}
              pages={pages}
              onFetchData={this.fetchData}
              loading={this.state.loading}
              filterable
              className="-striped -highlight"
              defaultPageSize={PAGE_SIZE}
              showPaginationBottom={true}
            />
          </PremiumTableShell>
        </div>
        {this.state.showTicketModal && (
          <TicketSuporteForm
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={initialTicketData}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getList }, dispatch);
export default connect(
  state => ({
    data: state.controladorErroGeralCad.list,
    total: state.controladorErroGeralCad.total,
  }),
  mapDispatchToProps,
)(ControladorErroGeralList);
